module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M19.958 18.078c0-1.73 1.442-1.166 2.074-4.338.264-1.316 1.538-.022 1.782-3.024 0-1.198-.696-1.496-.696-1.496s.354-1.77.492-3.134C23.782 4.388 22.552 0 16 0S8.218 4.388 8.39 6.086c.14 1.366.492 3.134.492 3.134s-.694.3-.694 1.496c.242 3.002 1.516 1.708 1.78 3.024.634 3.172 2.074 2.608 2.074 4.338 0 2.884-1.508 4.232-6.228 5.828C1.076 25.51 0 27.142 0 28.258v1.874C0 31.164.894 32 2 32h28c1.106 0 2-.836 2-1.87v-1.874c0-1.116-1.076-2.748-5.812-4.352-4.722-1.594-6.23-2.942-6.23-5.826z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/user-3.js
// module id = 1490
// module chunks = 14